import Dialog from "@mui/material/Dialog";
import { DoctorRoomAllocation } from "../../models";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";
import { apiAccessRequest } from "../../constants";
import { useUserContext } from "../../contexts";
import { useMsal } from "@azure/msal-react";

interface ConfirmDeleteAllocationProps {
	doctorRoomAllocation?: DoctorRoomAllocation;
	open: boolean;
	onClose: (updated: boolean) => void;
}

export const ConfirmDeleteAllocation = ({
	doctorRoomAllocation,
	open,
	onClose
}: ConfirmDeleteAllocationProps) => {
	const { account } = useUserContext();
	const { instance } = useMsal();
	const [isError, setIsError] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		setIsError(false);
		setIsLoading(false);
	}, [doctorRoomAllocation]);

	const handleConfirmClick = async () => {
		setIsError(false);
		setIsLoading(true);
		try {
			const requestUrl = `${process.env.REACT_APP_CONSULTS_URL}ClinicRoomDoctor`;
			const tokenResponse = await instance.acquireTokenSilent({
				account,
				scopes: apiAccessRequest.scopes
			});
			const headers = {
				Authorization: `Bearer ${tokenResponse.accessToken}`,
				"Content-Type": "application/json"
			};
			const body = [doctorRoomAllocation?.id];
			const response = await fetch(requestUrl, {
				method: "DELETE",
				headers,
				body: JSON.stringify(body)
			});

			if (!response.ok) {
				setIsError(true);
				return;
			}
			onClose(true);
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
		} catch (error) {
			setIsError(true);
		}

		setIsLoading(false);
	};

	return (
		<Dialog open={open}>
			<div
				className="flex flex-col items-center p-5 gap-4"
				style={{ width: 420 }}
			>
				{!isError && (
					<>
						<p className="ch-m-text ch-em-text-navy text-center">
							Delete Doctor Room Allocation
						</p>
						<p className="pb-3 text-center">
							You are going to delete room allocation for{" "}
							{doctorRoomAllocation?.doctorName} in room number{" "}
							{doctorRoomAllocation?.roomNumber} on{" "}
							{doctorRoomAllocation?.dayOfWeek}.
						</p>

						<div className="flex flex-col gap-4">
							{!isLoading && (
								<>
									<button
										className="ch-button ch-button-secondary justify-center"
										style={{ width: 280 }}
										onClick={() => handleConfirmClick()}
									>
										Delete Room Allocation
									</button>
									<button
										className="ch-button ch-button-primary justify-center"
										style={{ width: 280 }}
										onClick={() => onClose(false)}
									>
										Go Back
									</button>
								</>
							)}
							{isLoading && (
								<div className="flex justify-center py-3">
									<CircularProgress size="80px" />
								</div>
							)}
						</div>
					</>
				)}
				{isError && (
					<div className="flex flex-col items-center py-3">
						<img
							src="/images/svg/road-sign-warning.svg"
							height="50"
							alt="error icon"
						/>
						<p className="ch-m-text py-3 text-center">
							An error has occurred. The doctor room allocations have not been
							deleted. Try again later
						</p>
						<div className="flex gap-6">
							<button
								className="ch-button ch-button-primary"
								onClick={() => onClose(false)}
							>
								Go back
							</button>
						</div>
					</div>
				)}
			</div>
		</Dialog>
	);
};
